<template>
  <div v-show="showPromotion">
    <div
      id="campaign-banner"
      class="bg-cover py-4 md:py-5"
      :style="{ backgroundImage: `url(${assetsUrl(backgroundImageUrl)})`, backgroundPosition: backgroundPosition }"
    >
      <div
        class="co-container-sm flex flex-col px-4 lg:flex-row"
        style="max-width: 600px"
      >
        <div class="mb-4 basis-full px-0 text-center lg:mb-0 lg:basis-9/12">
          <img
            class="mx-auto w-[90%] md:w-3/4 lg:w-full"
            :src="$assetsUrl(titleImageUrl)"
            :alt="titleImageAlt"
            loading="lazy"
          >
        </div>
        <!-- トップページの場合は、/courseに遷移する -->
        <div
          v-if="topPage"
          class="flex basis-full items-center justify-center md:mr-auto lg:basis-3/12 lg:flex-col"
        >
          <a
            class="mr-2"
            href="/course"
            :style="{ color: `${textColor}` }"
          >
            <span class="co-mb-md-4 inline lg:block">コース紹介へ</span>
          </a>
          <a href="/course">
            <span class="te-btn-campaign te-bg-campaign flex items-center justify-center rounded-full text-co-gray-50">
              <FontAwesomeIcon
                :icon="faAngleRight"
                class="fa-fw size-3"
              />
            </span>
          </a>
        </div>
        <!-- トップページ以外は、#campaignに遷移 -->
        <div
          v-else
          class="mx-auto flex basis-full items-center justify-center px-4 md:mr-auto lg:basis-3/12 lg:flex-col"
        >
          <a
            class="mr-2"
            href="#campaign"
            :style="{ color: `${textColor}` }"
            @click.prevent="scrollTo('campaign')"
          >
            <span class="inline lg:block">お得情報を</span>
            <span class="inline lg:block">詳しく見る</span>
          </a>
          <a
            href="#campaign"
            @click.prevent="scrollTo('campaign')"
          >
            <span class="te-btn-campaign te-bg-campaign flex items-center justify-center rounded-full text-co-gray-50">
              <FontAwesomeIcon
                :icon="faAngleDown"
                class="fa-fw size-3"
              />
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faAngleRight, faAngleDown } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface Promotion {
  attributes: {
    alert_limited: string
    title_image_url: string
    title_image_alt: string
    background_image_url: string
    background_position: string
    text_color: string
    text_bg_color: string
    screen_names: string[]
  }
}

const options = {
  async setup() {
    return {
      faAngleRight,
      faAngleDown,
    }
  },
  props: {
    topPage: {
      type: Boolean,
    },
    currentPromotion: {
      type: Object as () => Promotion | null,
      default: null,
    },
    courseNamePath: {
      type: String,
      default: '',
    },
  },
  computed: {
    alertLimited(): string | null {
      return this.currentPromotion
        ? this.currentPromotion.attributes.alert_limited
        : null
    },
    titleImageUrl(): string | null {
      return this.currentPromotion
        ? this.currentPromotion.attributes.title_image_url
        : null
    },
    titleImageAlt(): string | null {
      return this.currentPromotion
        ? this.currentPromotion.attributes.title_image_alt
        : null
    },
    backgroundImageUrl(): string | null {
      return this.currentPromotion
        ? this.currentPromotion.attributes.background_image_url
        : null
    },
    backgroundPosition(): string | null {
      return this.currentPromotion
        ? this.currentPromotion.attributes.background_position
        : null
    },
    textColor(): string | null {
      return this.currentPromotion
        ? this.currentPromotion.attributes.text_color
        : null
    },
    textBgColor(): string | null {
      return this.currentPromotion
        ? this.currentPromotion.attributes.text_bg_color
        : null
    },
    showPromotion(): boolean {
      return this.currentPromotion
        ? this.currentPromotion.attributes.screen_names.includes(
            this.courseNamePath
          )
        : false
    },
  },
  methods: {
    assetsUrl(url: string): string {
      const { $assetsUrl } = useNuxtApp()
      return $assetsUrl(url)
    },
  },
  components: {
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-btn-campaign {
  width: 1.25rem;
  height: 1.25rem;
  transition: all 0.5s ease;
  @media (min-width: 992px) {
    width: 3rem;
    height: 3rem;
    font-size: 1.75rem;
  }
  &:hover {
    filter: brightness(0.8);
  }
}

/* // ボタンの背景色 */
.te-bg-campaign {
  background-color: #ee2576;
}
</style>
